document.querySelector('.js-header-menu').addEventListener('click', () => {
  document.body.classList.toggle('is_menu')
})

document.querySelectorAll('.header__navItem a').forEach((link) => {
  const href = link.getAttribute('href')
  if (href && href.startsWith('#')) {
    // hrefが#から始まるリンク
    link.addEventListener('click', () => {
      document.body.classList.remove('is_menu')
    })
  }
})

document.addEventListener('load', adjustHeader)
document.addEventListener('scroll', adjustHeader)

function adjustHeader() {
  const header = document.querySelector('.js-header')
  const mv = document.querySelector('.js-header-mv')

  if (!header || !mv) return

  if (document.documentElement.scrollTop <= mv.clientHeight) {
    header.classList.remove('is_fixed')
  } else {
    header.classList.add('is_fixed')
  }
}
